function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var OnePlayerGameTemplate = require('../../lib/templates/oneplayer-gametemplate');
var SpiderGameRulesTemplate = require('./lib/spider-game-rules.template');
var AppSettings = require('./lib/spider-settings');
var GameCardStack = require('../../lib/saito/ui/game-cardstack/game-cardstack');
var SaitoOverlay = require('../../lib/saito/ui/saito-overlay/saito-overlay');
var htmlTemplate = require('./lib/game-html.template');

//////////////////
// CONSTRUCTOR  //
//////////////////
var Spider = /*#__PURE__*/function (_OnePlayerGameTemplat) {
  function Spider(app) {
    var _this;
    _classCallCheck(this, Spider);
    _this = _callSuper(this, Spider, [app]);
    _this.app = app;
    _this.name = 'Spider';
    _this.slug = 'spider';
    _this.gamename = 'Spider Solitaire';
    _this.game_length = 10; //Estimated number of minutes to complete a game
    _this.description = 'Classic multideck solitaire game with three levels of difficulty available. Complete stacks of Ace through King in a single suit to remove them from the board. Partial stacks of the same suit can be moved to access the cards below them.';
    _this.categories = 'Games Cardgame One-player';
    _this.status = 'prod';
    _this["class"] = 'app';
    _this.difficulty = 2; //default medium, 1 = easy, 4 = hard

    _this.selected_stack = null;
    _this.possible_moves = null; //When using auto mode, some temporary memory
    _this.hints = null;
    return _this;
  }

  // Create an exp league by default
  _inherits(Spider, _OnePlayerGameTemplat);
  return _createClass(Spider, [{
    key: "respondTo",
    value: function respondTo(type) {
      if (type == 'default-league') {
        var obj = _superPropGet(Spider, "respondTo", this, 3)([type]);
        obj.ranking_algorithm = 'HSC';
        return obj;
      }
      return _superPropGet(Spider, "respondTo", this, 3)([type]);
    }
  }, {
    key: "returnGameRulesHTML",
    value: function returnGameRulesHTML() {
      return SpiderGameRulesTemplate(this.app, this);
    }
  }, {
    key: "initializeGame",
    value: function initializeGame(game_id) {
      console.log('SET WITH GAMEID: ' + game_id);
      if (!this.game.state) {
        console.log('******Generating the Game******');
        this.game.state = this.returnState();
        this.game.queue = [];
      }
      console.log(JSON.parse(JSON.stringify(this.game)));

      //Set difficulty
      var input_dif = this.loadGamePreference('spider-difficulty') || 'medium';
      this.changeDifficulty(input_dif);
      if (this.browser_active) {
        if (this.game.deck.length == 0) {
          this.newRound();
        }
      } else {
        this.game.queue.push('READY');
      }
    }
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
        var _this2 = this;
        var i;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(!this.browser_active || this.initialize_game_run)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.n = 2;
              return this.injectGameHTML(htmlTemplate());
            case 2:
              $('.gameboard').html(this.returnBoard());
              this.removeEvents();
              _context.n = 3;
              return _superPropGet(Spider, "render", this, 3)([app]);
            case 3:
              this.preloadImages();

              //
              // ADD MENU
              //
              this.menu.addMenuOption('game-game', 'Game');
              this.menu.addSubMenuOption('game-game', {
                text: 'Start New Game',
                id: 'game-new',
                "class": 'game-new',
                callback: function callback(app, game_mod) {
                  game_mod.menu.hideSubMenus();
                  game_mod.prependMove('lose');
                  game_mod.endTurn();
                }
              });
              this.menu.addSubMenuOption('game-game', {
                text: 'Settings',
                id: 'game-settings',
                "class": 'game-settings',
                callback: function callback(app, game_mod) {
                  game_mod.loadSettings();
                }
              });
              this.menu.addSubMenuOption('game-game', {
                text: 'How to Play',
                id: 'game-intro',
                "class": 'game-intro',
                callback: function callback(app, game_mod) {
                  game_mod.menu.hideSubMenus();
                  game_mod.overlay.showClosable(game_mod.returnGameRulesHTML());
                }
              });
              this.menu.addSubMenuOption('game-game', {
                text: 'Stats',
                id: 'game-stats',
                "class": 'game-stats',
                callback: function callback(app, game_mod) {
                  game_mod.menu.hideSubMenus();
                  game_mod.overlay.showClosable(game_mod.returnStatsHTML());
                }
              });
              this.menu.addChatMenu();
              this.menu.render();
              this.updateScore(0);
              this.cardStacks = [];
              for (i = 0; i < 10; i++) {
                this.cardStacks.push(new GameCardStack(app, this, i));
                //
                //Copy Board state from memory if it exists
                //
                if (this.game.state.board[i]) {
                  console.log('Load Last Board:', JSON.parse(JSON.stringify(this.game.state.board[i])));
                  this.cardStacks[i].cards = this.game.state.board[i];
                }
              }
              document.addEventListener('keydown', function (e) {
                if (e.ctrlKey && e.key === 'z') {
                  var _this2$moves;
                  if ((_this2$moves = _this2.moves) !== null && _this2$moves !== void 0 && _this2$moves.length) {
                    _this2.removeEvents();
                    _this2.updateScore();
                    _this2.undoMove();
                  }
                }
              });
            case 4:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render(_x) {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "newRound",
    value: function newRound() {
      //Set up queue
      this.game.queue = [];
      this.game.queue.push('play');
      this.game.queue.push('DEAL\t1\t1\t54');
      this.game.queue.push('SHUFFLE\t1\t1');
      this.game.queue.push('DECK\t1\t' + JSON.stringify(this.returnDeck(this.difficulty)));

      //Clear board -
      this.game.state.board = [];
      this.game.state.moves = 0;
      this.game.state.completed_stacks = [];
      this.game.state.score = 100 * this.difficulty;

      //Reset/Increment State
      this.game.state.draws_remaining = 5;
      if (this.browser_active) {
        this.updateScore(0);
        for (var i = 0; i < 10; i++) {
          this.cardStacks[i].clear();
          $('#helper').remove();
        }
      }
    }
  }, {
    key: "updateScore",
    value: function updateScore() {
      var change = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
      this.game.state.score += change;
      var el = document.querySelector('.spider-score');
      if (el) {
        el.textContent = "Score: ".concat(this.game.state.score);
      }
      if (this.game.state.score <= 0) {
        this.displayModal('You Lose!', 'Too many moves');
        this.prependMove('lose');
        this.endTurn();
      }
    }
  }, {
    key: "removeEvents",
    value: function removeEvents() {
      $('.undo').off();
      $('#hint').off();
      $('.draw-pile').off();
      $('.undo').css('opacity', '50%');
      $('#hint').css('opacity', '50%');
    }
  }, {
    key: "attachEventsToBoard",
    value: function attachEventsToBoard() {
      var _this$hints,
        _this3 = this;
      var spider_self = this;
      if (!this.browser_active) {
        return;
      }

      //Just in case
      this.removeEvents();

      //Undo last move
      if (this.moves.length > 0) {
        $('.undo').css('visibility', 'visible');
        $('.undo').css('opacity', '100%');
      } else {
        $('.undo').css('visibility', 'hidden');
      }
      $('.undo').on('click', function () {
        spider_self.removeEvents();
        spider_self.updateScore();
        spider_self.undoMove();
      });

      //Deal another round of cards

      $('.draw-pile').on('click', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var c;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!(spider_self.moves.length == 0 && spider_self.hints.length > 0)) {
                _context2.n = 2;
                break;
              }
              _context2.n = 1;
              return sconfirm('Deal without making any moves?');
            case 1:
              c = _context2.v;
              if (c) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              $('.gameboard').removeClass('nomoves');
              if (spider_self.game.state.draws_remaining > 0) {
                if (spider_self.canDraw()) {
                  spider_self.removeEvents();
                  spider_self.updateScore();
                  spider_self.prependMove('draw');
                  spider_self.endTurn();
                } else {
                  spider_self.displayWarning('Invalid Move', 'You cannot deal with open slots!');
                }
              } else {
                spider_self.prependMove('lose');
                spider_self.endTurn();
              }
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      })));
      for (var i = 0; i < 10; i++) {
        if (this.loadGamePreference('spider-play-mode') == 'auto') {
          this.cardStacks[i].applyFilter(this.canSelectAndMoveStack.bind(this), this.pickAndMoveStack.bind(this), false);
        } else {
          this.cardStacks[i].applyFilter(this.canSelectStack.bind(this), this.pickUpStack, false);
        }
      }
      if (((_this$hints = this.hints) === null || _this$hints === void 0 ? void 0 : _this$hints.length) > 0) {
        $('#hint').css('visibility', 'visible');
        $('#hint').css('opacity', '100%');
        $('.gameboard').removeClass('nomoves');
        $('#hint').on('click', function () {
          _this3.removeEvents();
          var next_hint = _this3.hints.shift();
          _this3.hints.push(next_hint);
          _this3.displayBoard();
          if (!document.getElementById('helper')) {
            _this3.app.browser.addElementToSelector("<div id=\"helper\" class=\"cardstack animated_elem\"></div>", '.gameboard');
          }
          _this3.invisible_scaffolding.push('dummy');
          _this3.cardStacks[next_hint.target].push('dummy');
          var helper = document.getElementById('helper');
          var divname = '#cardstack_' + next_hint.source + '_' + next_hint.index;
          var first_in_stack = document.querySelector(divname);
          var offset = parseInt(first_in_stack.style.top);
          $('#helper').css({
            top: first_in_stack.getBoundingClientRect().y,
            left: first_in_stack.getBoundingClientRect().x
          });
          helper.style.zIndex = 100;
          _this3.animationSpeed = 750;
          var as = "".concat(_this3.animationSpeed / 1000, "s");
          helper.style.transition = "left ".concat(as, ", top ").concat(as, ", width ").concat(as, ", height ").concat(as);
          for (var _i = next_hint.index; _i < _this3.cardStacks[next_hint.source].getCardCount(); _i++) {
            divname = '#cardstack_' + next_hint.source + '_' + _i;
            var elem = document.querySelector(divname);
            elem.style.top = "".concat(parseInt(elem.style.top) - offset, "px");
            helper.append(elem);
          }
          _this3.moveGameElement('helper', _this3.cardStacks[next_hint.target].getTopCardElement(), {}, function () {
            _this3.cardStacks[next_hint.target].pop();
            _this3.invisible_scaffolding = [];
            $('#helper').remove();
            _this3.cardStacks[next_hint.source].render();
            _this3.attachEventsToBoard();
          });
        });
      } else {
        $('#hint').css('visibility', 'hidden');
        $('.gameboard').addClass('nomoves');
      }
    }
  }, {
    key: "calculateHints",
    value: function calculateHints() {
      //Build hints
      this.hints = [];
      for (var i = 0; i < 10; i++) {
        //Get the maximum stack
        var last_card = this.cardStacks[i].getTopCardValue();
        if (!last_card) {
          continue;
        }
        var suit = last_card[0];
        var value = parseInt(last_card.substring(1));
        var stack_index = this.cardStacks[i].getCardCount() - 1;
        for (var j = stack_index - 1; j >= 0; j--) {
          var next_card = this.cardStacks[i].cards[j];
          if (parseInt(next_card.substring(1)) == ++value && next_card[0] == suit) {
            stack_index--;
          } else {
            break;
          }
        }

        //Requery value
        value = parseInt(this.cardStacks[i].cards[stack_index].substring(1)) + 1;

        // stack_index will be the depth of the maximum selectable substack from this stack
        // now we see if and where we can place it
        for (var _j = 0; _j < 10; _j++) {
          if (_j == i) {
            continue;
          }
          var bottom_card = this.cardStacks[_j].getTopCardValue();
          if (!bottom_card || parseInt(bottom_card.substring(1)) == value) {
            this.hints.push({
              source: i,
              target: _j,
              index: stack_index
            });
          }
        }
      }
    }
  }, {
    key: "canSelectStack",
    value: function canSelectStack(card_index, stack) {
      if (card_index == -1) {
        return false;
      }
      var card = stack.cards[card_index];
      var suit = card[0];

      //card must already be flipped over
      if (this.isFaceDown(card)) {
        return false;
      }
      var value = parseInt(card.slice(1));
      for (var i = card_index + 1; i < stack.cards.length; i++) {
        if (stack.cards[i][0] !== suit) {
          return false;
        }
        var temp_value = parseInt(stack.cards[i].slice(1));
        if (temp_value !== --value) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "canPlaceStack",
    value: function canPlaceStack(card_index, stack) {
      if (card_index === -1) {
        return true;
      }
      var card = stack.cards[card_index];
      var spider_self = stack.mod;
      var moving_card = spider_self.selected_stack[0];
      var moving_card_number = parseInt(moving_card.slice(1));
      var number = parseInt(card.slice(1));
      if (this.isFaceDown(moving_card)) {
        return false;
      }
      if (number == moving_card_number + 1) {
        return true;
      }
      return false;
    }
  }, {
    key: "canSelectAndMoveStack",
    value: function canSelectAndMoveStack(card_index, stack) {
      if (this.canSelectStack(card_index, stack)) {
        var _card = stack.cards[card_index];
        var spider_self = stack.mod;
        for (var i = 0; i < 10; i++) {
          if (spider_self.cardStacks[i].getCardCount() > 0) {
            var bottom_card = spider_self.cardStacks[i].getTopCardValue();
            var value1 = parseInt(bottom_card.slice(1));
            var value2 = parseInt(_card.slice(1));
            if (value1 == value2 + 1) {
              return true;
            }
          } else {
            //Can move on to blank spot
            return true;
          }
        }
      }
      return false;
    }
  }, {
    key: "pickAndMoveStack",
    value: function pickAndMoveStack(activated_card_stack, card_index, event) {
      var spider_self = activated_card_stack.mod;
      var stack_to_move = activated_card_stack.cards.slice(card_index);
      var sameStack = function sameStack(stack_to_move) {
        if (!spider_self.selected_stack) {
          return false;
        }
        if (spider_self.moves.length == 0) {
          return false;
        }
        var lastMove = spider_self.moves[0].split('\t');
        if (lastMove[0] == 'flip') {
          lastMove = spider_self.moves[1].split('\t');
        }
        //Check move meta data first that we are clicking where the last move landed
        if (activated_card_stack.name == lastMove[2] && parseInt(lastMove[3]) == stack_to_move.length) {
          return true;
        }
        return false;
      };
      if (!sameStack(stack_to_move)) {
        spider_self.selected_stack = stack_to_move;
        spider_self.possible_moves = [];
        var _card2 = activated_card_stack.cards[card_index];
        for (var i = 0; i < 10; i++) {
          if (parseInt(activated_card_stack.name) == i) {
            continue;
          }
          if (spider_self.cardStacks[i].getCardCount() == 0) {
            spider_self.possible_moves.push(i);
          } else {
            var bottom_card = spider_self.cardStacks[i].getTopCardValue();
            var value1 = parseInt(bottom_card.slice(1));
            var value2 = parseInt(_card2.slice(1));
            if (value1 == value2 + 1) {
              spider_self.possible_moves.push(i);
            }
          }
        }
        if (card_index > 0) {
          var card_above = activated_card_stack.cards[card_index - 1];
          var _value = parseInt(card_above.slice(1));
          var _value2 = parseInt(_card2.slice(1));
          if (_value == _value2 + 1) {
            spider_self.possible_moves.push(parseInt(activated_card_stack.name));
          }
        }
        if (spider_self.possible_moves.length > 1) {
          spider_self.possible_moves.sort(function (a, b) {
            if (a == parseInt(activated_card_stack.name)) {
              return 1;
            }
            if (b == parseInt(activated_card_stack.name)) {
              return -1;
            }
            var a_card = spider_self.cardStacks[a].getTopCardValue();
            var b_card = spider_self.cardStacks[b].getTopCardValue();
            if (b_card && b_card[0] === _card2[0] && (!a_card || a_card[0] !== _card2[0])) {
              return 1;
            }
            if (a_card && a_card[0] === _card2[0] && (!b_card || b_card[0] !== _card2[0])) {
              return -1;
            }
            if (!b_card && a_card) {
              return 1;
            }
            if (b_card && !a_card) {
              return -1;
            }
            return a - b;
          });
        }
      }
      var target = spider_self.possible_moves.shift();
      spider_self.possible_moves.push(target);
      for (var _i2 = 0; _i2 < 10; _i2++) {
        spider_self.cardStacks[_i2].removeFilter();
      }
      spider_self.moveStack(activated_card_stack.name, card_index, target);
    }
  }, {
    key: "moveStack",
    value: function moveStack(source, index, target) {
      var _this4 = this;
      index = parseInt(index);
      target = parseInt(target);
      source = parseInt(source);
      if (!document.getElementById('helper')) {
        this.app.browser.addElementToSelector("<div id=\"helper\" class=\"cardstack animated_elem\"></div>", '.gameboard');
      }
      var card = this.cardStacks[source].cards[index];
      this.invisible_scaffolding.push(card);
      this.cardStacks[target].push(card);
      var helper = document.getElementById('helper');
      var divname = '#cardstack_' + source + '_' + index;
      var first_in_stack = document.querySelector(divname);
      var offset = parseInt(first_in_stack.style.top);
      $('#helper').css({
        top: first_in_stack.getBoundingClientRect().y,
        left: first_in_stack.getBoundingClientRect().x
      });
      helper.style.zIndex = 100;

      //>>>>>>>> Change the animation speed!
      this.animationSpeed = 450;
      var as = "".concat(this.animationSpeed / 1000, "s"); //Make it faster
      helper.style.transition = "left ".concat(as, ", top ").concat(as, ", width ").concat(as, ", height ").concat(as);
      for (var i = index; i < this.cardStacks[source].getCardCount(); i++) {
        divname = '#cardstack_' + source + '_' + i;
        var elem = document.querySelector(divname);
        elem.style.top = "".concat(parseInt(elem.style.top) - offset, "px");
        helper.append(elem);
      }
      this.removeEvents();
      this.moveGameElement('helper', this.cardStacks[target].getTopCardElement(), {
        callback: function callback() {
          var stack_to_move = _this4.cardStacks[source].cards.splice(index);
          //drop the first card we already added
          stack_to_move.shift();
          //Concat the rest of the stack
          var _iterator = _createForOfIteratorHelper(stack_to_move),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _card3 = _step.value;
              _this4.cardStacks[target].cards.push(_card3);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          _this4.commitMove(source + '_' + index, target, stack_to_move.length + 1);
        }
      }, function () {
        _this4.invisible_scaffolding = [];
        $('#helper').remove();
        _this4.cardStacks[target].render();
        _this4.cardStacks[source].render();
        if (!_this4.checkStack(target)) {
          _this4.calculateHints();
          setTimeout(_this4.attachEventsToBoard.bind(_this4), 5);
        }
      });
    }
  }, {
    key: "placeStack",
    value: function placeStack(activated_card_stack, card_index, event) {
      var spider_self = activated_card_stack.mod;
      var _iterator2 = _createForOfIteratorHelper(spider_self.selected_stack),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _card4 = _step2.value;
          activated_card_stack.cards.push(_card4);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      activated_card_stack.render();
      spider_self.selected_stack = [];
      $('#helper').remove();
    }
  }, {
    key: "pickUpStack",
    value: function pickUpStack(activated_card_stack, card_index, event) {
      var spider_self = activated_card_stack.mod;
      var af = null;
      spider_self.removeEvents();
      if (!document.getElementById('helper')) {
        spider_self.app.browser.addElementToSelector("<div id=\"helper\" class=\"cardstack\"></div>", '.gameboard');
      }
      var helper = document.getElementById('helper');
      $('.gameboard').addClass('selection');

      //
      // Note: The cardstack element(s) has a top value so they make a stack, we style.top so that clicking
      // the 2 elment of the stack or the 20th element of the stack yield the same vertical offset
      //
      var offsetY = event.clientY - Math.round(event.currentTarget.getBoundingClientRect().y - parseInt(event.currentTarget.style.top));
      var offsetX = event.clientX - Math.round(event.currentTarget.getBoundingClientRect().x);
      var xposition = event.clientX - offsetX + 5;
      var yposition = event.clientY - offsetY + 5;
      $('.gameboard').on('mousemove', function (e) {
        xposition = e.clientX - offsetX;
        yposition = e.clientY - offsetY;
      });
      var _animate = function animate() {
        $('#helper').css({
          top: yposition,
          left: xposition
        });
        af = requestAnimationFrame(_animate);
      };
      _animate();

      //Move card stack cards into helper
      for (var i = card_index; i < activated_card_stack.cards.length; i++) {
        var divname = '#cardstack_' + activated_card_stack.name + '_' + i;
        helper.append(document.querySelector(divname));
        //$("#helper").append($(divname));
      }
      spider_self.selected_stack = activated_card_stack.cards.splice(card_index);
      for (var _i3 = 0; _i3 < 10; _i3++) {
        ////////////////////////
        // Move Card!
        ///////////////////////
        spider_self.cardStacks[_i3].applyFilter(spider_self.canPlaceStack.bind(spider_self), /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(target_card_stack) {
            var num_of_cards_to_move, top_card_to_move;
            return _regenerator().w(function (_context3) {
              while (1) switch (_context3.n) {
                case 0:
                  window.cancelAnimationFrame(af);
                  num_of_cards_to_move = spider_self.selected_stack.length;
                  top_card_to_move = "".concat(activated_card_stack.name, "_").concat(card_index);
                  spider_self.placeStack(target_card_stack);
                  _context3.n = 1;
                  return spider_self.commitMove(top_card_to_move, target_card_stack.name, num_of_cards_to_move);
                case 1:
                  if (!spider_self.checkStack(target_card_stack.name)) {
                    spider_self.calculateHints();
                    setTimeout(spider_self.attachEventsToBoard.bind(spider_self), 20);
                  }
                case 2:
                  return _context3.a(2);
              }
            }, _callee3);
          }));
          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }());
      }
      activated_card_stack.applyFilter(function () {
        return true;
      }, function (param) {
        window.cancelAnimationFrame(af);
        spider_self.placeStack(param);
        spider_self.attachEventsToBoard();
      });
    }
  }, {
    key: "commitMove",
    value: function () {
      var _commitMove = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(source, target, stackSize) {
        var key;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              this.updateScore();
              this.prependMove("move\t".concat(source, "\t").concat(target, "\t").concat(stackSize));
              this.game.state.moves++;
              _context4.n = 1;
              return this.revealCard(source[0]);
            case 1:
              key = _context4.v;
              if (key) {
                this.prependMove("flip\t".concat(source[0], "\t").concat(key));
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function commitMove(_x3, _x4, _x5) {
        return _commitMove.apply(this, arguments);
      }
      return commitMove;
    }()
  }, {
    key: "revealCard",
    value: function () {
      var _revealCard = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(stackNum) {
        var topCard, realCard, card_to_reveal;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              stackNum = parseInt(stackNum);

              //Reveal card under stack (if necessary)
              if (!(this.cardStacks[stackNum].getCardCount() > 0)) {
                _context5.n = 4;
                break;
              }
              topCard = this.cardStacks[stackNum].pop(false); //console.log("Reveal: " + topCard);
              if (!this.isFaceDown(topCard)) {
                _context5.n = 3;
                break;
              }
              realCard = this.game.deck[0].cards[topCard]; //Save "decoded" card to game state
              this.cardStacks[stackNum].push(realCard, false);
              card_to_reveal = this.cardStacks[stackNum].getTopCardElement();
              if (!card_to_reveal) {
                _context5.n = 2;
                break;
              }
              card_to_reveal.innerHTML = this.returnCardImageHTML(realCard);
              _context5.n = 1;
              return this.timeout(30);
            case 1:
              card_to_reveal.classList.remove('facedown');
              card_to_reveal.classList.add('faceup');
              _context5.n = 2;
              return this.timeout(300);
            case 2:
              return _context5.a(2, topCard);
            case 3:
              this.cardStacks[stackNum].push(topCard, false);
            case 4:
              return _context5.a(2, null);
          }
        }, _callee5, this);
      }));
      function revealCard(_x6) {
        return _revealCard.apply(this, arguments);
      }
      return revealCard;
    }()
  }, {
    key: "undoMove",
    value: function undoMove() {
      var mv = this.moves.shift().split('\t');
      console.log('Undo: ' + mv);
      if (mv[0] === 'flip') {
        var key = mv[2];
        var _slot = parseInt(mv[1]);
        var _card5 = this.cardStacks[_slot].pop(false);
        this.cardStacks[_slot].push(key);
        this.undoMove();
        return;
      }
      if (mv[0] == 'complete') {
        this.game.state.completed_stacks.pop();
        var _slot2 = parseInt(mv[1]);
        for (var i = 13; i > 0; i--) {
          this.cardStacks[_slot2].push("".concat(mv[2]).concat(i));
        }
        this.undoMove();
        return;
      }
      var original_card_pos = mv[1];
      var slot = parseInt(mv[2]);
      var stackSize = parseInt(mv[3]);
      var oldstackNum = parseInt(original_card_pos[0]);
      var moved_cards = this.cardStacks[slot].cards.splice(-stackSize);
      var _iterator3 = _createForOfIteratorHelper(moved_cards),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _card6 = _step3.value;
          this.cardStacks[oldstackNum].cards.push(_card6);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      this.game.state.moves++;
      this.displayBoard();
      this.calculateHints();
      this.attachEventsToBoard();
    }

    /*
      Check if we have completed a stack
    */
  }, {
    key: "checkStack",
    value: function checkStack(stackNum) {
      var _this5 = this;
      if (this.cardStacks[stackNum].getCardCount() < 13) {
        return false;
      }
      var tempStack = [];
      var success = true;
      var lastCard = this.cardStacks[stackNum].cards.slice(-1)[0];
      var suit = lastCard[0];
      for (var i = 1; i <= 13 && success; i++) {
        var _card7 = this.cardStacks[stackNum].pop(false);
        tempStack.push(_card7);
        if (this.isFaceDown(_card7)) {
          success = false;
          break;
        }
        if (suit !== _card7[0]) {
          success = false;
          break;
        }
        if (parseInt(_card7.substring(1)) != i) {
          success = false;
          break;
        }
      }

      //Put the cards back
      if (!success) {
        while (tempStack.length > 0) {
          card = tempStack.pop();
          this.cardStacks[stackNum].push(card, false);
        }
        return false;
      } else {
        this.updateScore(50);
        this.game.state.completed_stacks.push(suit);
        var numComplete = this.game.state.completed_stacks.length;
        this.prependMove("complete\t".concat(stackNum, "\t").concat(suit));
        $('.completed_stack_box').append("<div id=\"cs".concat(numComplete, "\" class=\"completed_stack\"></div>"));
        var depth = this.cardStacks[stackNum].getCardCount();
        for (var _i4 = 0; _i4 < 13; _i4++) {
          this.animationSequence.unshift({
            callback: this.moveGameElement,
            params: [this.copyGameElement("#cardstack_".concat(stackNum, "_").concat(depth + _i4)), "#cs".concat(numComplete), {
              resize: 1,
              insert: 1
            }]
          });
        }
        this.animationSequence.unshift({
          callback: function callback() {
            _this5.cardStacks[stackNum].render();
          },
          params: null
        });
        this.animationSequence.push({
          callback: function callback() {
            setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
              var temp;
              return _regenerator().w(function (_context6) {
                while (1) switch (_context6.n) {
                  case 0:
                    _this5.displayBoard();
                    $('.animated_elem').remove();
                    _this5.halted = 0;
                    _context6.n = 1;
                    return _this5.revealCard(stackNum);
                  case 1:
                    temp = _context6.v;
                    if (temp) {
                      _this5.prependMove("flip\t".concat(stackNum, "\t").concat(temp));
                    }
                    if (_this5.game.state.completed_stacks.length == 8) {
                      _this5.prependMove('win');
                      _this5.endTurn();
                    } else {
                      _this5.calculateHints();
                      _this5.attachEventsToBoard();
                    }
                  case 2:
                    return _context6.a(2);
                }
              }, _callee6);
            })), 1000);
          },
          params: null
        });
        this.runAnimationQueue(100);
        return true;
      }
    }
  }, {
    key: "canDraw",
    value: function canDraw() {
      for (var i = 0; i < 10; i++) {
        if (this.cardStacks[i].getCardCount() == 0) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "isFaceDown",
    value: function isFaceDown(card) {
      if (card[0] == 'S' || card[0] == 'C' || card[0] == 'H' || card[0] == 'D') return false;else return true;
    }
  }, {
    key: "handleGameLoop",
    value: function handleGameLoop() {
      var _this6 = this;
      var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var spider_self = this;
      this.saveGame(this.game.id);
      ///////////
      // QUEUE //
      ///////////
      if (this.game.queue.length > 0) {
        var qe = this.game.queue.length - 1;
        var mv = this.game.queue[qe].split('\t');
        var shd_continue = 1;
        if (mv[0] === 'lose') {
          this.game.queue.splice(qe, 1);
          var final_score = 0;
          if (this.game.state.moves > 0) {
            console.log('Process loss');
            this.game.state.session.round++;
            this.game.state.session.losses++;
            final_score = this.game.state.score;
            this.game.state.scores.push(final_score);
          }
          this.newRound();
          if (final_score > 0) {
            this.game.queue.push("ROUNDOVER\t".concat(JSON.stringify([]), "\t").concat(final_score, "\t").concat(JSON.stringify([this.publicKey])));
          }
          return 1;
        }
        if (mv[0] === 'win') {
          this.game.queue.splice(qe, 1);
          this.game.state.session.round++;
          this.game.state.session.wins++;
          this.animateFinalVictory();
          var _final_score = this.game.state.score + 400;
          this.game.state.scores.push(_final_score);
          this.overlay.showClosable(this.returnStatsHTML('Winner!'), function () {
            _this6.newRound();
            _this6.game.queue.push("ROUNDOVER\t".concat(JSON.stringify([_this6.publicKey]), "\t").concat(_final_score, "\t").concat(JSON.stringify([])));
            $('.completed_card').remove();
            _this6.restartQueue();
          });
          return 0;
        }
        if (mv[0] === 'draw') {
          this.game.state.draws_remaining--;
          this.game.queue.splice(qe, 1);
          this.game.queue.push("DEAL\t1\t1\t10");
        }

        /*
          Build the board from the shuffled deck
        */
        if (mv[0] === 'play') {
          if (this.browser_active) {
            /* We want to deal the cards onto the table, each stack is an array*/
            var indexCt = 0;
            console.log('play');
            this.displayBoard();
            if (this.game.deck[0].hand.length == 0) {
              this.calculateHints();
              this.attachEventsToBoard();
              return 0;
            }
            console.log('Animate card deal');
            $('.empty_slot').remove();
            this.animationSpeed = 900;
            while (this.game.deck[0].hand.length > 0) {
              var _card8 = this.game.deck[0].hand.pop();
              this.invisible_scaffolding.push(_card8);
              this.cardStacks[indexCt].push(_card8);
              this.animationSequence.push({
                callback: this.moveGameElement,
                params: [this.createGameElement("<img class=\"cardBack\" src=\"/spider/img/cards/red_back.png\"/>", '.draw-pile'), "#cardstack_".concat(indexCt, "_").concat(this.cardStacks[indexCt].getCardCount() - 1), {
                  resize: 1,
                  insert: 1
                }]
              });
              indexCt = (indexCt + 1) % 10;
            }
            this.animationSequence.push({
              delay: 200,
              params: null
            });
            this.animationSequence.push({
              callback: this.displayBoard,
              params: null
            });

            //Flip bottom row
            for (var i = 0; i < 10; i++) {
              this.animationSequence.push({
                callback: this.revealCard,
                params: [i]
              });

              //Set our saveable state to a reference of the cardstacks array
              this.game.state.board[i] = this.cardStacks[i].cards;
            }
            this.animationSequence.push({
              callback: this.finishAnimation,
              params: null
            });
            this.runAnimationQueue(120);
          }
          return 0;
        }
        if (mv[0] === 'flip') {
          this.game.queue.splice(qe, 1);
          if (this.game.player !== 1) {
            this.displayBoard();
            this.revealCard(mv[1]);
          }
        }
        if (mv[0] === 'complete') {
          this.game.queue.splice(qe, 1);
          var slot = parseInt(mv[1]); //rowX_slotY
          if (this.game.player !== 1) {
            for (var _i5 = 0; _i5 < 13; _i5++) {
              this.cardStacks[slot].pop();
            }
          }
        }
        if (mv[0] === 'move') {
          this.game.queue.splice(qe, 1);
          var _card9 = mv[1]; //rowX_slotY
          var emptySlot = mv[2]; //rowX_slotY

          if (this.game.player !== 1) {
            //this.moveStack(card, emptySlot);
            this.game.state.moves++;
          }
        }
        return 1;
      }
      return 0;
    }
  }, {
    key: "animateFinalVictory",
    value: function () {
      var _animateFinalVictory = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var cards, max_x, max_y, i;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              $('.card.completed_card').css('width', '100px');
              $('.gameboard').append($('.card.completed_card'));
              cards = document.querySelectorAll('.card.completed_card');
              max_x = window.innerWidth - 50;
              max_y = window.innerHeight - 100;
              i = 0;
            case 1:
              if (!(i < cards.length)) {
                _context7.n = 3;
                break;
              }
              cards[i].style.left = Math.floor(Math.random() * max_x) + 25;
              cards[i].style.top = Math.floor(Math.random() * max_y) + 50;
              _context7.n = 2;
              return this.timeout(50);
            case 2:
              i++;
              _context7.n = 1;
              break;
            case 3:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function animateFinalVictory() {
        return _animateFinalVictory.apply(this, arguments);
      }
      return animateFinalVictory;
    }()
  }, {
    key: "finishAnimation",
    value: function finishAnimation() {
      var _this7 = this;
      setTimeout(function () {
        console.log('Animation finished');
        $('.animated_elem').remove();
        _this7.restartQueue();
      }, 400);
    }
  }, {
    key: "returnBoard",
    value: function returnBoard() {
      var html = "<div class=\"card-stack-array\">";
      for (var i = 0; i < 10; i++) {
        html += "<div id=\"cardstack_".concat(i, "\"></div>");
      }
      html += '</div>';
      html += "<div class=\"spider-footer\">\n              <div class=\"completed_stack_box\"></div>\n              <div class=\"spider-score\"></div>\n              <div class=\"icon_container\">\n                <div id=\"hint\" class=\"hint\"><i class=\"fa-solid fa-question fa-border\"></i></div>\n                <div class=\"undo\"><i class=\"fas fa-undo fa-border\"></i></div>\n              </div>\n              <div class=\"draw-pile\">New Game</div>\n            </div>\n            ";
      return html;
    }
  }, {
    key: "changeDifficulty",
    value: function () {
      var _changeDifficulty = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(dif) {
        var old_dif, c;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              old_dif = this.loadGamePreference('spider-difficulty');
              this.saveGamePreference('spider-difficulty', dif);
              if (this.browser_active) {
                _context8.n = 1;
                break;
              }
              return _context8.a(2);
            case 1:
              if (dif == 'easy') {
                this.difficulty = 1;
              } else if (dif == 'hard') {
                this.difficulty = 4;
              } else {
                this.difficulty = 2;
              }
              if (!(this.game.deck.length && dif !== old_dif)) {
                _context8.n = 3;
                break;
              }
              _context8.n = 2;
              return sconfirm('Abandon this game?');
            case 2:
              c = _context8.v;
              if (c) {
                this.game.queue.push('lose');
                this.endTurn();
              }
            case 3:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function changeDifficulty(_x7) {
        return _changeDifficulty.apply(this, arguments);
      }
      return changeDifficulty;
    }()
  }, {
    key: "displayBoard",
    value: function displayBoard() {
      console.log('REFRESH BOARD');
      if (this.browser_active == 0) {
        return;
      }

      //Don't load card images...
      this.invisible_scaffolding = [];
      for (var i = 0; i < 10; i++) {
        this.cardStacks[i].render();
      }
      var html = '';
      var dp = document.querySelector('.draw-pile');
      if (dp) {
        if (this.game.state.draws_remaining > 0) {
          dp.style.backgroundImage = 'url(/spider/img/cards/red_back.png)';
          html = "<div>".concat(this.game.state.draws_remaining, "</div><div>Deal").concat(this.game.state.draws_remaining > 1 ? 's' : '', "</div>");
        } else {
          dp.style.backgroundImage = 'unset';
          html = '<span>Start</span><span>New</span><span>Game</span>';
        }
        dp.innerHTML = html;
      }

      //Completed stacks
      html = '';
      for (var _i6 = 0; _i6 < this.game.state.completed_stacks.length; _i6++) {
        html += "<div class=\"completed_stack\">";
        for (var j = 0; j < 13; j++) {
          html += "<div class=\"card-slot faceup\" style=\"position:absolute;right:".concat(j, "px;bottom:").concat(j, "px\">").concat(this.returnCardImageHTML(this.game.state.completed_stacks[_i6] + (j + 1)), "</div>");
        }
        html += '</div>';
      }
      document.querySelector('.completed_stack_box').innerHTML = html;
    }
  }, {
    key: "returnState",
    value: function returnState() {
      var state = _superPropGet(Spider, "returnState", this, 3)([]);
      state.moves = 0;
      state.score = 100 * this.difficulty;
      state.recycles_remaining = 5;
      state.completed_stacks = [];
      state.board = [];
      state.scores = [];

      //    for (let i = 0; i < 10; i++) {
      //      state.board.push([]);
      //    }

      return state;
    }
  }, {
    key: "returnCardImageHTML",
    value: function returnCardImageHTML(name) {
      if (this.invisible_scaffolding && this.invisible_scaffolding.includes(name)) {
        return '';
      }
      if (!this.isFaceDown(name)) {
        return "<img class=\"cardFront\" src=\"/spider/img/cards/".concat(name, ".png\" />\n              <img class=\"cardBack\" src=\"/spider/img/cards/red_back.png\" />");
      } else {
        return '<img src="/spider/img/cards/red_back.png" />';
      }
    }
  }, {
    key: "returnDeck",
    value: function returnDeck(numSuits) {
      var suits = ['S', 'D', 'C', 'H'];
      var deck = {};
      /* WTF is with this indexing system??? */
      //2-10 of each suit, with indexing gaps on the 1's
      var index = 1;
      var numLoops = 104 / (13 * numSuits);
      for (var k = 0; k < numLoops; k++) {
        for (var i = 0; i < numSuits; i++) {
          for (var j = 1; j <= 13; j++) {
            deck[index.toString()] = suits[i] + j;
            index++;
          }
        }
      }
      return deck;
    }
  }, {
    key: "preloadImages",
    value: function preloadImages() {
      var suits = ['S', 'D', 'C', 'H'];
      var allImages = [];
      for (var i = 0; i < this.difficulty; i++) {
        for (var j = 1; j <= 13; j++) {
          allImages.push(suits[i] + j);
        }
      }
      this.preloadImageArray(allImages, 0);
    }
  }, {
    key: "preloadImageArray",
    value: function preloadImageArray(imageArray) {
      var _this8 = this;
      var idx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var pre_images = [imageArray.length];
      if (imageArray && imageArray.length > idx) {
        pre_images[idx] = new Image();
        pre_images[idx].onload = function () {
          _this8.preloadImageArray(imageArray, idx + 1);
        };
        pre_images[idx].src = '/spider/img/cards/' + imageArray[idx] + '.png';
      }
    }
  }, {
    key: "hasSettings",
    value: function hasSettings() {
      return true;
    }
  }, {
    key: "loadSettings",
    value: function loadSettings() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (!container) {
        // The shared game overlay is created without a close box. Settings needs
        // its own overlay so the standard top-right close control is present,
        // including when the panel fills the screen on mobile.
        if (!this.settings_overlay) {
          this.settings_overlay = new SaitoOverlay(this.app, this);
        }
        this.menu.hideSubMenus();
        this.settings_overlay.show("<div class=\"module-settings-overlay retain-surface\"><h2>Spider Solitaire Settings</h2></div>");
        container = '.module-settings-overlay';
      }
      var as = new AppSettings(this.app, this, container);
      as.render();
    }
  }]);
}(OnePlayerGameTemplate);
module.exports = Spider;